<template>
    <div>
        <div v-show="isMask" class="mask"></div>
        <div class="tab-item">
            <!-- <div class="btn">
            </div> -->
            <div class="item-sale">
                <div class="left">
                    <div class="div0">提报售点</div>
                    <div class="div1">
                        <!-- v-if="isChange"  -->
                        <!-- @change="changeSelect(regionCodenew)" -->
                        <el-select
                            class="select"
                            v-if="regionCodearr.length > 0"
                            style="margin: 0px 25px 0px 0px;width:150px"
                            v-model="regionCodenew"
                            size="small"
                            placeholder="请选择regionCode"
                            >
                            <el-option
                            v-for="item in regionCodearr"
                            :key="item.regionCode"
                            :label="item.regionName.split('|')[0]"
                            :value="item.regionCode">
                            </el-option>
                        </el-select>
                        <span style="margin: 0px 0px 0px 0px;color:#cd1231;">已添加：{{formatPrice(partNumberadd(regionCodenew)||0)}}{{ showText }}</span>
                        <span style="margin: 0px 0px 0px 5px;color:#cd1231;">/</span>
                        <span style="margin: 0px 0px 0px 5px;color:#cd1231;">剩余可添加：{{formatPrice(partNumber(regionCodenew)||0)}}{{ showText }}</span>
                    </div>
                    <div class="div2">
                        <el-button type="primary" style="background-color:rgba(0, 117, 255, 1);text-align:center;" @click="addSale()">
                            <span v-if="isEmptypoint">添加活动执行地址</span>
                            <span v-else>添加售点</span>
                        </el-button>
                        <el-popover
                        v-if="!isEmptypoint"
                        placement="top"
                        width="500"
                        popper-class="myPopover"
                        v-model="isPoverdialog">
                        <div class="shuju">
                            <div class="left">数据文件</div>
                            <div class="right">
                                <FileUpload
                                ref="execTemplateIdRef"
                                :upload-param="{ filePath: 'temp' }"
                                :save-item = "execTemplate"
                                show-type="text"
                                @uploaded="getExecTemplateId"
                                @removed="clearExecTemplateId" >
                                <div class="right-top">点击上传</div>
                                </FileUpload>
                            </div>
                        </div>
                        <div class="muban">
                            <div class="left">模板文件</div>
                            <div class="right" @click="clickExcel()">
                                <!-- <a :href="templateFile" target="_blank">点击下载模板文件</a> -->
                                点击下载模板文件
                            </div>
                        </div>
                        <div style="text-align: center; margin: 0">
                            <el-button size="mini" type="danger" style="width:70px;margin: 10px 30px 10px 0px" plain @click="isPoverdialog = false">关闭</el-button>
                            <el-button type="danger" size="mini" style="width:70px;" @click="confirmUpload()">确认上传</el-button>
                        </div>
                        <el-button   type="primary" style="background-color:rgba(0, 117, 255, 1);text-align:center;margin-left:15px;"   slot="reference">批量添加售点</el-button>
                        </el-popover>

                    </div>
                </div>
                <div class="right">
                    <el-table
                        ref="myTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        border
                        show-header
                        :span-method="objectSpanMethod"
                        >
                        <el-table-column
                        align="center"
                        label="BU"
                        show-overflow-tooltip
                        width="60"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.buName !== null"> {{(scope.row.buName).split('|')[0]}}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="销售大区"
                        width="80"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.regionName !== null"> {{(scope.row.regionName).split('|')[0]}}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="isEmptypoint"
                        align="center"
                        label="城市"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.areaName }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        :label="isEmptypoint? '活动地点':'街区名称'"
                        width="80"
                        show-overflow-tooltip
                        v-if="isManypoint || isEmptypoint"
                        >
                        <template slot-scope="scope">{{ scope.row.block_name }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="售点名称"
                        v-if="!isEmptypoint"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">{{ scope.row.pocName }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="售点联系人"
                        v-if="!isEmptypoint"
                        >
                        <template slot="header">
                            <!-- <i class="el-icon-edit" style="color:#539EFE;margin-right: 3px;"></i> -->
                            <!-- <span>售点联系人</span> -->
                        </template>

                        <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.contactPerson"  @change="changeInput(scope.row)" clearable>{{ scope.row.contactPerson }}</el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        width="180"
                        v-if="!isEmptypoint"
                        >
                        <template slot="header">
                            <!-- <i class="el-icon-edit" style="color:#539EFE;margin-right: 3px;"></i> -->
                            <span>售点联系方式</span>
                        </template>
                        <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.contactPhone"  @change="changeInput(scope.row)" clearable>{{ scope.row.contactPhone }}</el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="售点地址"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.pocAddress }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="百威联系人"
                        >
                        <template  slot-scope="scope">
                            <!-- v-if="!isManypoint" -->
                            <el-input
                            size="small"
                            class="input-baiwei"
                            v-model="scope.row.bwContactPerson"
                            @change="changeInput(scope.row)"
                            clearable>
                                {{ scope.row.bwContactPerson }}
                            </el-input>
                            <!-- <span  v-else  class="input-baiwei">
                                {{ scope.row.bwContactPerson }}
                            </span> -->
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="活动日期"
                        width="100"
                        >
                        <template  slot-scope="scope">
                            <div style="display:flex">
                                <div style="color:#409eff;margin:auto;" >
                                    {{ scope.row.timeList.length }}天
                                    <i class="el-icon-date" style="color:#409eff;cursor: pointer;" @click="showDatePicker(scope.row)"></i>
                                </div>
                                <!-- :ref="'changeFocus' + (scope.row.igniteId)" -->
                                <DatePicker
                                    :ref=" isSinglepoint ? 'changeFocus' + (scope.row.igniteId) : 'changeFocus' + (scope.row.timeStamp) "
                                    align="right"
                                    style="width:0px;overflow: hidden;height:0;margin-top:-30px"
                                    :readonly="false"
                                    :theme-start-time="popData.themeBasic.themeStartTime"
                                    :theme-end-time="popData.themeBasic.themeEndTime"
                                    @handleChangeDate="handleChangeDate"
                                    />
                                <!-- <el-date-picker
                                style="width:0px;overflow: hidden;"
                                @change="changeInput(scope.row)"
                                @focus="focusInput(scope.row)"
                                type="dates"
                                value-format="yyyy-MM-dd"
                                v-model="scope.row.timeList"
                                :picker-options="pickerOptions(popData.themeBasic)"
                                placeholder="选择一个或多个日期"
                                size="small"
                                clearable
                                :default-value="defauleTime"
                                >
                                </el-date-picker> -->
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="操作"
                        width="100"
                        >
                        <template slot-scope="scope">
                            <!-- v-if="scope.row.activityStatus !== 0" -->
                            <div  style="display:flex;justify-content: center;">
                                <div v-if="isManypoint || isEmptypoint"  style="margin-right:10px;" class="store-name" >
                                    <div  @click="clickOperate(scope.row)">
                                        换店
                                    </div>
                                </div>
                                <div  class="store-name">
                                    <el-popconfirm
                                    @confirm="deleteRow(scope.row)"
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="是否确认删除？"
                                    >
                                    <div slot="reference">删除</div>
                                    </el-popconfirm>
                                </div>
                            </div>
                            <!-- <div v-else style="display:flex;justify-content: center;">
                                <el-tag type="danger" size="small" style="margin-right:5px;">退</el-tag>
                                <div style="margin-right:50px;" class="store-name" >
                                    <div  @click="clickOperatereturn(scope.row)">
                                        修改
                                    </div>
                                </div>
                                <div  class="store-name">
                                    <el-popconfirm
                                    @confirm="deleteRowreturn(scope.row)"
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="是否确认删除？"
                                    >
                                    <div slot="reference">删除</div>
                                    </el-popconfirm>
                                </div>
                            </div> -->
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div  v-show="isMask && !isEmptydialog && !isErrordialog" class="dialog">
            <SinglePoint
            v-if="isSinglepoint && isSingledialog"
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleChange="handleChange"
            @handleChangereturn="handleChangereturn"
            ></SinglePoint>
            <ManyPoint
            v-if="isManypoint && isManydialog "
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleSelectionChange="handleSelectionChange"
            @handleSelectionChangereturn="handleSelectionChangereturn"
            ></ManyPoint>
        </div>
        <div  v-show="isMask && isEmptydialog && !isErrordialog" class="dialog2">
            <EmptyPoint
            v-if="isEmptypoint && isEmptydialog "
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleEmptyChange="handleEmptyChange"
            @handleEmptyChangereturn="handleEmptyChangereturn"
            @deleteRow="deleteRow"

            ></EmptyPoint>
        </div>
        <div  v-if="isErrordialog" class="dialogError">
            <div class="dialogError-top">
                <div  style="flex: 1;">不合格数据</div>
                <i class="el-icon-close" style="cursor: pointer;font-size: 25px;"  @click="closeMask"></i>
            </div>
            <div class="dialogError-main">
                <el-table
                ref="errorTable"
                :data="errorList"
                tooltip-effect="dark"
                style="width: 100%"
                :show-header='false'
                >
                    <el-table-column
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row }}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from "@/utils/common"
    import PopoverPop from './activity-report-add-popover.vue'
    import SinglePoint from './activity-report-single-point.vue'
    import ManyPoint from './activity-report-many-point.vue'
    import EmptyPoint from './activity-report-empty-point.vue'
    import FileUpload from '@/components/file-upload'
    import gameplanApi from '../../../api/gameplan'
    import DatePicker from "./date-picker.vue";
    export default {
      name: 'activity-report-add-pop-table',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        igniteOptions:{type:Object, default:()=>{}},
        regionCode:{type:String, default:''},
        timeItem:{type:Object, default:()=>{}},
        isChange:{type:Boolean,default:true},
        showText:{type:String, default:''},
        detailDTOList:{type:Array, default: () => []},
        gpActivityInfoVOList:{type:Array, default:()=>[] },
      },
      components: {
        SinglePoint,
        ManyPoint,
        EmptyPoint,
        FileUpload,
        DatePicker
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            multipleSelection: [],
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            isSinglepoint: false, // 单售点
            isManypoint: false, // 多售点
            isSingledialog: false, // 单售点
            isManydialog: false, // 多售点
            isEmptypoint: false, // 无售点
            isEmptydialog: false,// 无售点
            isMask: false,
            options:{},
            searchList:{},
            isDangerbtn:false,
            pocCountMin:'', //最小关联售点
            popData:[],
            dialogVisible: false,
            isPoverdialog: false,
            dataFileId:"",
            execTemplate:[],
            templateFile: '',
            rowActivityId:'',
            isErrordialog: false,
            errorList:[],
            successList:{},
            igniteRuleDTOList:[],
            pickerOptions(row = {}) {
                return{
                    disabledDate (time) {
                        // time.getTime() < Date.now() - 8.64e7 ||
                        return   time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
            regionCodearr: [],
            regionCodenew: '',
            notReportCountQty: 0,// 全部可添加场次
            isExcessnum: false, // 是否超额
            defauleTime:'',
            excelName:'',
            igniteOptionsnew: {},
            rowTimebegin:[]
        }
      },
      watch: {},
      created () {
        this.popData = this.popDataitem
        this.themeDetail =  this.popDataitem.themeDetail
        this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        // console.log(this.popData,'提报添加--popData');
        let themeName = this.popData.themeBasic.themeName
        let themeChannelName = this.popData.themeDetail.themeChannelName
        let themeStyleName = this.popData.themeDetail.themeStyleName
        let themeLevelName = this.popData.themeDetail.themeLevelName
        let excelNametop = themeName + '-' + themeChannelName + '-' + themeStyleName
        if (themeLevelName !== null) {
            excelNametop = excelNametop + '-' + themeLevelName
        }
        // this.themeDetail.pocRelateType == '1'  判断单1 多售点 2 和无售点 0
        if (this.themeDetail.pocRelateType == '1') {
            this.isSinglepoint = true
            this.isManypoint = false
            this.isEmptypoint = false
            this.excelName = excelNametop + '- ' + '单售点'
        } else if (this.themeDetail.pocRelateType == '2') {
            this.isSinglepoint = false
            this.isManypoint = true
            this.isEmptypoint = false
            this.excelName = excelNametop + '- ' + '多售点'

        } else {
            this.isSinglepoint = false
            this.isManypoint = false
            this.isEmptypoint = true
            this.templateFile = ''
        }
        this.init()
      },
      mounted () {},
      updated() {
        this.partTimenumber()
        this.partNumber(this.regionCodenew)
        this.partNumberadd(this.regionCodenew)
      },
      methods: {
        init () {
            this.regionCodearr = this.detailDTOList
            this.regionCodenew = this.regionCodearr[0].regionCode
            let num = 0
            for (let item of this.regionCodearr) {
                num = num + item.notReportCountQty
            }
            this.notReportCountQty = num
            if(this.gpActivityInfoVOList&&this.gpActivityInfoVOList.length>0){
              if(this.isEmptypoint){
                this.gpActivityInfoVOList.forEach(saveItem=>{
                  let copyPocItem = Object.assign({},saveItem.gpActivityInfoDTO)
                  copyPocItem.timeList = saveItem.gpActivityTimeDTOList.map(timeItem=>{
                    return timeItem.activityTime
                  })
                  copyPocItem.pocAddress = saveItem.gpActivityInfoDTO.blockAddress
                  copyPocItem.block_name = saveItem.gpActivityInfoDTO.blockName
                  copyPocItem.areaCode = saveItem.gpActivityInfoDTO.areaCode
                  copyPocItem.blockName = saveItem.gpActivityInfoDTO.blockName
                  this.tableData.splice(this.tableData.length,0,copyPocItem)
                })
              }else if(this.isSinglepoint||this.isManypoint){
                this.gpActivityInfoVOList[0].gpActivityPocDTOList.forEach((pocItem,index)=>{
                  let copyPocItem = Object.assign({},pocItem)
                  copyPocItem.timeList = this.gpActivityInfoVOList[0].gpActivityTimeDTOList.map(timeItem=>{
                    return timeItem.activityTime
                  })
                  copyPocItem.buName = this.gpActivityInfoVOList[0].gpActivityInfoDTO.buName
                  copyPocItem.regionName = this.gpActivityInfoVOList[0].gpActivityInfoDTO.regionName
                  copyPocItem.buCode = this.gpActivityInfoVOList[0].gpActivityInfoDTO.buCode
                  copyPocItem.regionCode = this.gpActivityInfoVOList[0].gpActivityInfoDTO.regionCode
                  copyPocItem.block_name = this.gpActivityInfoVOList[0].gpActivityInfoDTO.blockName
                  copyPocItem.areaCode = this.gpActivityInfoVOList[0].gpActivityInfoDTO.areaCode
                  copyPocItem.blockName = this.gpActivityInfoVOList[0].gpActivityInfoDTO.blockName
                  this.tableData.splice(this.tableData.length,0,copyPocItem)
                  if(index===0) this.streetArr.push(this.gpActivityInfoVOList[0].gpActivityPocDTOList.length)
                  else this.streetArr.push(0)
                })
              }
              this.aconfirmAdd()
            }
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 点击图标显示日期组件
        clickDate (row) {
            // console.log(row,'clickDate');
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            if (this.isSinglepoint) {
                //this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.igniteId}`].focus()
                //})
            } else {
                //this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.timeStamp}`].focus()
                //})
            }
        },
        showDatePicker(row){
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            console.log(this);
            const timeList = row.timeList.map(item=>{
            const date = new Date(item.replace(/-/g, '/'))
            return date.getTime()
           })
        //    console.log(this.isSinglepoint);
        //    console.log(`changeFocus${row.igniteId}`,`changeFocus${row.timeStamp}`);
           this.focusInput(row)
            if (this.isSinglepoint) {
                this.$nextTick(()=>{
                  this.$refs[`changeFocus${row.igniteId}`].showDatePicker(timeList,row)
                })
            } else {
                this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.timeStamp}`].showDatePicker(timeList,row)
                })
            }
          // this.$refs.datePickerRef.showDatePicker(timeList)
        },
        handleChangeDate(selectList,is,row){
            const itemList = this.tableData.filter(item=>{
                const itemKey = this.isSinglepoint?'igniteId':'timeStamp'
                return item[itemKey] == row[itemKey]
            })
            if(itemList.length!==0){
            //   const timeList = itemList[0].timeList
            //   let dateList = timeList.concat(selectList)
              let dateList = selectList
              dateList = [...new Set(dateList)]
              dateList.sort((a, b) => {
                return new Date(a.replace(/-/g, '/')) <new Date(b.replace(/-/g, '/')) ? -1 : 1
                // return a < b ? -1 : 1
              })
              itemList[0].timeList = dateList
              itemList[0].timeListStr = dateList.join(',')
            }
            if (this.isSinglepoint) {
                this.$refs[`changeFocus${row.igniteId}`].hideDatePicker()
            } else {
                this.$refs[`changeFocus${row.timeStamp}`].hideDatePicker()
            }
            this.changeInput(itemList[0])
        //   this.searchForm.timeList = dateList
        //   this.searchForm.timeListStr = dateList.join(',')
        //   this.$refs.datePickerRef.hideDatePicker()
        },
        // 兼职单独提示
        partTimenumber () {
            for (let item of  this.regionCodearr) {
                // console.log(item,'item-兼职单独提示');
                let allNum = 0
                if (this.themeDetail.needTransitions == 0) {
                    if (this.isSinglepoint || this.isEmptypoint) {
                        let partArr = []
                        for (let item2 of this.tableData) {
                            if (item2.regionCode == item.regionCode ) {
                                partArr.push(item2)
                            }
                        }
                        allNum = partArr.length
                        // console.log(partArr,allNum,'partArr--01---0000');
                        // if (allNum > item.notReportCountQty) {
                        //     this.$message.warning(`${item.regionName}超出未提报场次`)
                        //     return true
                        // }
                    } else if (this.isManypoint){
                        let arr = []
                        for (let item3 of this.tableData) {
                            arr.push(item3)
                        }
                        let newArr = []
                        let obj = {}
                        newArr = arr.reduce(function (item, next) {
                            obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                            return item
                        }, [])
                        let partArr = []
                        for (let item4 of newArr) {
                            if (item4.regionCode == item.regionCode) {
                                partArr.push(item4)
                            }
                        }
                        allNum = partArr.length
                        // if (allNum > item.notReportCountQty) {
                        //     this.$message.warning(`${item.regionName}超出未提报场次`)
                        //     return true
                        // }
                        // console.log(partArr,allNum,'partArr--2---0000');
                    }
                }
                else if (this.themeDetail.needTransitions == 1) {
                    if (this.isSinglepoint || this.isEmptypoint) {
                        let partArr = []
                        for (let item5 of this.tableData) {
                            if (item5.regionCode == item.regionCode ) {
                                partArr.push(item5)
                            }
                        }
                        for (let item6 of partArr) {
                            allNum = allNum + item6.timeList.length
                        }
                        // console.log(partArr,allNum,'partArr--01---1111');
                        // if (allNum > item.notReportCountQty) {
                        //     this.$message.warning(`${item.regionName}超出未提报场次`)
                        //     return true
                        // }
                    } else if (this.isManypoint){
                        let arr = []
                        for (let item7 of this.tableData) {
                            arr.push(item7)
                        }
                        let newArr = []
                        let obj = {}
                        newArr = arr.reduce(function (item, next) {
                            obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                            return item
                        }, [])
                        let partArr = []
                        for (let item8 of newArr) {
                            if (item8.regionCode == item.regionCode) {
                                partArr.push(item8)
                            }
                        }
                        for (let item9 of partArr) {
                            allNum = allNum + item9.timeList.length
                        }
                        // console.log(partArr,allNum,'partArr--2---1111');
                        // if (allNum > item.notReportCountQty) {
                        //     this.$message.warning(`${item.regionName}超出未提报场次`)
                        //     return true
                        // }
                        // else {
                        //     this.$message.warning(`${item.regionName}没有超出提报场次`)
                        // }
                    }
                }
                else {
                    this.$message.warning('数据错误')
                    return
                }
                if (allNum > item.notReportCountQty) {
                    this.$message.warning(`${(item.regionName).split("|")[0]}超出未提报场次，应选择${item.notReportCountQty} ${this.showText},你选择了${allNum} ${this.showText}`)
                    this.isExcessnum = true
                    return
                } else {
                    this.isExcessnum = false
                    return
                }
            }
        },
        // 兼职单独剩余可添加数量
        partNumber (code) {
            // console.log(code,'code');
            for (let item of  this.regionCodearr) {
                // console.log(item,'item');
                if (code  == item.regionCode) {
                    let allNum = 0
                    if (this.themeDetail.needTransitions == 0 && this.tableData.length > 0) {
                        if (this.isSinglepoint || this.isEmptypoint) {
                            let partArr = []
                            for (let item2 of this.tableData) {
                                if (item2.regionCode == code ) {
                                    partArr.push(item2)
                                }
                            }
                            allNum = allNum + partArr.length
                        } else if (this.isManypoint){
                            let arr = []
                            for (let item3 of this.tableData) {
                                arr.push(item3)
                            }
                            let newArr = []
                            let obj = {}
                            newArr = arr.reduce(function (item, next) {
                                obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                                return item
                            }, [])
                            let partArr = []
                            for (let item4 of newArr) {
                                if (item4.regionCode == item.regionCode) {
                                    partArr.push(item4)
                                }
                            }
                            allNum = partArr.length
                        }
                    }
                    else if (this.themeDetail.needTransitions == 1 && this.tableData.length > 0) {
                        if (this.isSinglepoint || this.isEmptypoint) {
                            // let partArr = []
                            // for (let item5 of this.tableData) {
                            //     if (item5.regionCode == item.regionCode ) {
                            //         partArr.push(item5)
                            //     }
                            // }
                            // for (let item6 of partArr) {
                            //     allNum = allNum + item6.timeList.length
                            // }
                            this.tableData.forEach(tableItem=>{
                              if(tableItem.regionCode===item.regionCode){
                                allNum = allNum + tableItem.timeList.length
                              }
                            })
                        } else if (this.isManypoint){
                            let arr = []
                            for (let item7 of this.tableData) {
                                arr.push(item7)
                            }
                            let newArr = []
                            let obj = {}
                            newArr = arr.reduce(function (item, next) {
                                obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                                return item
                            }, [])
                            let partArr = []
                            for (let item8 of newArr) {
                                if (item8.regionCode == item.regionCode) {
                                    partArr.push(item8)
                                }
                            }
                            for (let item9 of partArr) {
                                allNum = allNum + item9.timeList.length
                            }
                        }
                    }
                    // console.log(item.notReportCountQty,'item.notReportCountQty');
                    // console.log(item.notReportCountQty - allNum,'allNum-剩余');
                    return item.notReportCountQty - allNum
                }
            }
        },
        // 兼职单独已添加数量
        partNumberadd (code) {
            for (let item of  this.regionCodearr) {
                if (code  == item.regionCode) {
                    let allNum = 0
                    if (this.themeDetail.needTransitions == 0 && this.tableData.length > 0) {
                        if (this.isSinglepoint || this.isEmptypoint) {
                            let partArr = []
                            for (let item2 of this.tableData) {
                                if (item2.regionCode == code ) {
                                    partArr.push(item2)
                                }
                            }
                            allNum = allNum + partArr.length
                        } else if (this.isManypoint){
                            let arr = []
                            for (let item3 of this.tableData) {
                                arr.push(item3)
                            }
                            let newArr = []
                            let obj = {}
                            newArr = arr.reduce(function (item, next) {
                                obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                                return item
                            }, [])
                            let partArr = []
                            for (let item4 of newArr) {
                                if (item4.regionCode == item.regionCode) {
                                    partArr.push(item4)
                                }
                            }
                            allNum = partArr.length
                        }
                    }
                    else if (this.themeDetail.needTransitions == 1 && this.tableData.length > 0) {
                        if (this.isSinglepoint || this.isEmptypoint) {
                            let partArr = []
                            for (let item5 of this.tableData) {
                                if (item5.regionCode == item.regionCode ) {
                                    partArr.push(item5)
                                }
                            }
                            for (let item6 of partArr) {
                                allNum = allNum + item6.timeList.length
                            }
                        } else if (this.isManypoint){
                            let arr = []
                            for (let item7 of this.tableData) {
                                arr.push(item7)
                            }
                            let newArr = []
                            let obj = {}
                            newArr = arr.reduce(function (item, next) {
                                obj[next.block_name] ? '' : obj[next.block_name] = true && item.push(next)
                                return item
                            }, [])
                            let partArr = []
                            for (let item8 of newArr) {
                                if (item8.regionCode == item.regionCode) {
                                    partArr.push(item8)
                                }
                            }
                            for (let item9 of partArr) {
                                allNum = allNum + item9.timeList.length
                            }
                        }
                    }
                    // console.log(allNum,'allNum-add');
                    return  allNum
                }
            }
        },
        // regioncode 下拉框选择
        changeSelect (item) {
            // console.log(item,'下拉框选择--item',this.regionCodenew,'下拉框选择-regionCodenew');
            this.$emit('getChildcode',this.regionCodenew)
            for (let item1 of  this.regionCodearr) {
                if (item1.regionCode == this.regionCodenew) {
                    let obj = item1.igniteRuleObj
                    Object.keys(obj).forEach(function(key){
                        if (obj[key] ==null) {
                            obj[key]=[]
                        }
                    });
                    this.igniteOptionsnew = obj
                }
            }
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        focusInput (row) {
            this.rowTimebegin = row.timeList
            // console.log( this.rowTimebegin,' this.rowTimebegin');
        },
        changeInput (row) {
            if (row && this.isManypoint) {
                for (const item1 of this.tableData) {
                    if (item1.block_name == row.block_name) {
                        item1.bwContactPerson = row.bwContactPerson
                        item1.timeList = row.timeList
                    }

                }
            }
            if (this.themeDetail.needTransitions == 0) {
                if (this.themeDetail.perExecDays) {
                    if (row.timeList.length  !== this.themeDetail.perExecDays) {
                        this.$message.error(`选择日期天数应与执行天数相等,当前已选 ${row.timeList.length}天，应选 ${this.themeDetail.perExecDays}天`)
                        // if (row.timeList.length - this.themeDetail.perExecDays > 0) {
                        //     // row.timeList = row.timeList.slice(row.timeList.length - this.themeDetail.perExecDays,row.timeList.length)
                        //     row.timeList = row.timeList.slice(0,this.themeDetail.perExecDays)
                        // }
                        // if (row.timeList.length - this.themeDetail.perExecDays < 0) {
                        //     row.timeList = this.rowTimebegin
                        // }
                        row.timeList = this.rowTimebegin
                        return
                    }
                } else {
                    this.$message.warning('配置天数未返回')
                    return
                }
            } else {
                if (row.timeList.length == 0) {
                    this.$message.warning('配置天数不能为0')
                    // return
                }
                let num = this.partNumber(row.regionCode)
                if (num < 0) {
                    this.$message.warning('添加场次超过可添加场次')
                    // return
                }
            }
            this.aconfirmAdd()
        },
        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },
        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        getExecTemplateId (file) {
            this.dataFileId = file.fileId
        },
        clearExecTemplateId (file) {
            this.dataFileId = ''
        },
        async getpocImport () {
            this.$emit('setLoading',true)
            let params = {
                "dataFileId":this.dataFileId,
                "themeId":this.themeDetail.themeId,
                "themeDetailId":this.themeDetail.themeDetailId
            }
            let res =  await gameplanApi.getpocImport(params)
            if (res.data.resultCode == '0') {
                let data = res.data.resultData
                let activityInfoList = data.activityInfoList
                this.errorList = data.errorList
                this.$emit('setLoading',false)
                if (this.errorList.length  >  0 ) {
                    this.isMask = true
                    this.isErrordialog = true
                    this.lockScroll()
                    return
                } else {
                    this.isMask = false
                    this.isErrordialog = false
                }
                console.log(activityInfoList,'activityInfoList');

                if (this.isSinglepoint == true) {
                    let singleArr = []
                    for (let item1 of activityInfoList) {
                        for (let item2 of item1.gpActivityPocDTOList) {
                            item2.blockName = item1.blockName
                            item2.block_name = item1.blockName
                            item2.timeList = item1.oldTime
                            singleArr.push(item2)
                        }
                    }
                    // console.log(singleArr,'singleArr');
                    this.tableData =  singleArr
                    this.aconfirmAdd()
                } else if (this.isManypoint == true) {
                    let manyArr = []
                    let i = 0
                    for (let item1 of activityInfoList) {
                        for (let item2 of item1.gpActivityPocDTOList) {
                            item2.blockName = item1.blockName
                            item2.block_name = item1.blockName
                            item2.timeList = item1.oldTime
                            item2.timeStamp = i
                            manyArr.push(item2)
                        }
                        i++
                    }
                    this.tableData = manyArr
                    this.merge(this.tableData)
                    this.aconfirmAdd()
                } else{
                    return
                }
            } else {
                this.$emit('setLoading',false)
            }
        },
        //获取模板文件
        getpocExcel () {
            console.log(this.themeDetail.themeDetailId,'this.themeDetail.themeDetailId');
            gameplanApi.getpocExcel(this.themeDetail.themeDetailId).then((res) =>{
                    let blob = res.data;
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = window.URL.createObjectURL(blob);  //创建下载的链接
                    tempLink.download = this.excelName + "导入模板.xlsx"; //下载后文件名
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    // document.body.removeChild(tempLink); //下载完成移除元素
                    // window.URL.revokeObjectURL(tempLink.href); //释放掉blob对象
            })
        },
        clickExcel () {
            this.getpocExcel()
        },
        //确认上传
        confirmUpload () {
            this.isPoverdialog = false
            this.getpocImport()
        },
        // 删除售点
        async deletePoc (val) {
            let res = await gameplanApi.deletePocinformation(val[0])
            if (res.data.resultCode == '0') {
                this.$message.success("删除成功")
                // this.$router.go(0)
            }
        },
        // 修改售点
        async updatePoc (val) {
            let res = await gameplanApi.updatePocinformation(val[0])
            if (res.data.resultCode == '0') {
                this.$message.success("修改成功")
                // this.$router.go(0)
            }
        },
        deleteRowreturn(row){
            let popData =  this.popData
            let themeBasic = this.popData.themeBasic
            if (this.isEmptypoint) {
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":row.blockName,
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":row.blockAddress,
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                        }
                        ,
                        "gpActivityPocDTOList": []
                    }
                ]
                // console.log(arr,'arr-deleteRow-isEmptypoint');
                this.deletePoc(arr)
            } else if (this.isSinglepoint) {
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":'',
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                        }
                        ,
                        "gpActivityPocDTOList":
                        [{
                            "activityPocId":row.activityPocId,
                            "cityName": row.cityName,
                            "contactPerson": row.contactPerson,
                            "contactPhone": row.contactPhone,
                            "igniteId": row.igniteId,
                            "pocAddress": row.pocAddress,
                            "pocName": row.pocName,
                            "pocPoiId": row.pocPoiId,
                            "provinceName": row.provinceName,
                        }]
                    }
                ]
                // console.log(arr,'arr-deleteRow-isSinglepoint');
                this.deletePoc(arr)
            } else if (this.isManypoint) {
                let itemArr = []
                for (let i = 0; i < this.tableData.length; i++) {
                    // console.log(this.tableData[i],'item');
                    if (this.tableData[i].block_name == row.block_name) {
                        // itemArr.push(this.tableData[i])
                        itemArr.push({
                            "activityPocId":this.tableData[i].activityPocId,
                            "cityName": this.tableData[i].cityName,
                            "contactPerson": this.tableData[i].contactPerson,
                            "contactPhone": this.tableData[i].contactPhone,
                            "igniteId": this.tableData[i].igniteId,
                            "pocAddress": this.tableData[i].pocAddress,
                            "pocName": this.tableData[i].pocName,
                            "pocPoiId": this.tableData[i].pocPoiId,
                            "provinceName": this.tableData[i].provinceName,
                        })
                    }
                }
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":row.block_name,
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                        }
                        ,
                        "gpActivityPocDTOList": itemArr
                    }
                ]
                this.deletePoc(arr)
            } else {
                return
            }
        },
        clickOperatereturn(row){
            this.rowActivityId = row.activityId
            if (this.isSinglepoint) {
                this.rowActivityList  = row
                // console.log( this.rowActivityList,'rowActivityList-isSinglepoint');
                let arr = []
                arr.push(row)
                this.addSaleReturn(arr)
            } else if (this.isManypoint) {
                this.rowBlockname = row.block_name
                let arr = []
                for (let item of this.tableData) {
                    if (item.block_name == row.block_name ) {
                        arr.push(item)
                    }
                }
                console.log(arr);
                let reviseObj = {
                    'selectList':arr,
                    'foodStreet':row.block_name
                }
                this.addSaleReturn(reviseObj)
            } else {
                let arr = []
                arr.push(row)
                this.addSaleReturn(arr)
            }
        },
        addSaleReturn (val) {
            let reviseObj = val
            let obj = {
                'themeCode' : this.themeDetail.themeStyleCode,
                'themeDetailId':this.themeDetail.themeDetailId,
                'igniteRuleObj':this.igniteOptionsnew,
                'pocCountMin':this.pocCountMin,
                'pocRelateType':this.themeDetail.pocRelateType,
                'reviseObj': reviseObj,
                'singleData': [],
                'router':'06',
                'activityReturn':true,
            }
            this.searchList = obj
            if (this.isSinglepoint) {
                this.isSingledialog = true
                this.isMask = true

            } else if (this.isManypoint) {
                this.isMask = true
                this.isManydialog = true

            } else if (this.isEmptypoint) {
                this.isMask = true
                this.isEmptydialog = true
            }
        },
        handleChangereturn (val) {
            console.log(val,'9999-单');
            let tableList = val
            let tableArr = []
            let popData =  this.popData
            let themeBasic = this.popData.themeBasic
            for (let item of tableList) {
                    tableArr.push({
                        "gpActivityInfoDTO":
                        {
                            "activityId":this.rowActivityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":'',
                            "areaCode":item.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                        }
                        ,
                        "gpActivityPocDTOList":
                        [{
                            "activityPocId":item.activityPocId,
                            "cityName": item.cityName,
                            "contactPerson": item.contactPerson,
                            "contactPhone": item.contactPhone,
                            "igniteId": item.igniteId,
                            "pocAddress": item.pocAddress,
                            "pocName": item.pocName,
                            "pocPoiId": item.pocPoiId,
                            "provinceName": item.provinceName,
                        }]
                    })
            }
            this.updatePoc(tableArr)

        },
        arrHandleReturn (arr) {
            let popData =  this.popData
            let themeBasic = this.popData.themeBasic
            let array =JSON.parse(JSON.stringify(arr))
            let result = []
            array.map(e => {
                return {
                    gpActivityInfoDTO: {
                        "activityId":this.rowActivityId,
                        "beginTime": themeBasic.themeStartTime,
                        "buToCity": themeBasic.buToCity,
                        "endTime": themeBasic.themeEndTime,
                        "themeChannelCode": popData.themeDetail.themeChannelCode,
                        themeChannelName:popData.themeDetail.themeChannelName,
                        "themeId": themeBasic.themeId,
                        "themeLevelCode":  popData.themeDetail.themeLevelCode,
                        "themeStyleCode":  popData.themeDetail.themeStyleCode,
                        'themeDetailId': popData.themeDetail.themeDetailId,
                        "blockName":e.block_name,
                        "areaCode":e.areaCode, // 新加
                        "blockPoi":'',
                        "blockAddress":'',
                        "blockLongitude":'',
                        "blockLatitude":'',
                        "signInLongitude":'',
                        "signInLatitude":'',
                    },
                    gpActivityPocDTOList: array.filter(g => g.block_name == e.block_name).map(h => {
                        return {
                            "activityPocId":h.activityPocId,
                            "cityName": h.cityName,
                            "contactPerson": h.contactPerson,
                            "contactPhone": h.contactPhone,
                            "igniteId": h.igniteId,
                            "pocAddress": h.pocAddress,
                            "pocName": h.pocName,
                            "pocPoiId": h.pocPoiId,
                            "provinceName": h.provinceName,
                        }
                    })
                    }
                    }).forEach(e => {
                        result.push(e)
                        // result.findIndex(f => f.gpActivityInfoDTO?.block_name == e.gpActivityInfoDTO?.block_name) == -1 && result.push(e)
                    });
            for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < i; j++) {
                    if (result[i].gpActivityInfoDTO.blockName == result[j].gpActivityInfoDTO.blockName) {
                        result.splice(j,1)
                        i--
                    }
                }
            }
            // console.log(result,'result--详情-审批中-多售点组装');
            this.updatePoc(result)
        } ,
        handleSelectionChangereturn (val) {
            this.arrHandleReturn(val)
        },
        handleEmptyChangereturn (val) {
            // console.log(val,'9999-空');
            let tableList = val
            let tableArr = []
            let popData =  this.popData
            let themeBasic = this.popData.themeBasic
            for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].blockName == tableList[0].block_name && this.tableData[i].blockAddress == tableList[0].pocAddress ) {
                    this.$message.warning('街区售点已存在，请重新选择')
                    return
                }
            }

            for (let item of tableList) {
                    tableArr.push({
                        "gpActivityInfoDTO":
                        {
                            "activityId":this.rowActivityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":item.block_name,
                            "areaCode":item.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":item.pocAddress,
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            "assignStartTime":  this.timeItem.assignStartTime,
                            "assignEndTime":  this.timeItem.assignEndTime,
                            'assignId':this.timeItem.assignId
                        }
                        ,
                        "gpActivityPocDTOList": []
                    })
            }
            // console.log(tableArr,'tableArr');
            this.updatePoc(tableArr)
        },
        getOptionsName(a,b,g) {
            let c = a;
            let d = []
            let e = g
            let f = []
            for (let i in e) {
                let obj = {}
                obj[i] = e[i]
                for (let i2 of c) {
                    if (i == i2) {
                        f.push(e[i])
                    }
                }
            }
            let arr = f.map((item) => {
                    return item
                }).join(b)
            return arr
        },
        // 初始化合并行数组
        mergeInit() {
        this.streetArr = []; //合并街道
        this.streeIndex = 0; //合并街道索引
        },
    //  合并表格
        merge(data) {
            this.mergeInit();
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr.push(1); //合并医院
                        this.streeIndex = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].block_name == data[i - 1].block_name) {
                        this.streetArr[this.streeIndex] += 1;
                        this.streetArr.push(0);
                        } else {
                        this.streetArr.push(1);
                        this.streeIndex = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            const len = this.tableData.length;
            if (this.isManypoint) {
                 if(columnIndex === 0 || columnIndex === 1 ||columnIndex === 2 || columnIndex === 7 ||columnIndex === 8 ||columnIndex === 9){
                    const _row_1 = this.streetArr[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                    };
                } else if(rowIndex === len){
                    return {
                    rowspan:1,
                    colspan:1
                    }
                }
            }
        },
        deleteRow (row) {
            // console.log(row,'deleteRow');
            if (this.isSinglepoint) {
                for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].igniteId == row.igniteId){
                        this.tableData.splice(i,1)
                    }
                }
            } else if(this.isManypoint) {
                for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].block_name == row.block_name){
                        this.tableData.splice(i,1)
                        i--
                    }
                }
                if (this.$refs.myTable && this.$refs.myTable.doLayout) {
                    this.merge(this.tableData)
                    this.$refs.myTable.doLayout();
                }
            } else if(this.isEmptypoint) {
                if (row.blockAddress) {
                    for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].pocAddress == row.blockAddress && this.tableData[i].areaCode == row.areaCode  && this.tableData[i].block_name == row.blockName){
                        this.tableData.splice(i,1)
                        i--
                    }
                }
                } else {
                    for(let i=0;i<this.tableData.length;i++){
                        if(this.tableData[i].pocAddress == row.pocAddress && this.tableData[i].block_name == row.block_name && this.tableData[i].areaCode == row.areaCode && this.tableData[i].bwContactPerson == row.bwContactPerson){
                            this.tableData.splice(i,1)
                            i--
                        }
                    }
                }
            }
            this.aconfirmAdd()
        },
        clickOperate (row) {
            for (let item of this.detailDTOList) {
                if (item.regionCode == row.regionCode) {
                    this.regionCodenew = item.regionCode
                }
            }
            if (this.isManypoint) {
                let arr = []
                for (let item of this.tableData) {
                    if (item.block_name == row.block_name ) {
                        arr.push(item)
                    }
                }
                let reviseObj = {
                    'selectList':arr,
                    'foodStreet':row.block_name,
                    'bwContactPerson':row.bwContactPerson,
                    'areaCode':row.areaCode,
                    'timeList':row.timeList
                }
                this.addSale(reviseObj)

            } else {
                let arr = []
                // console.log(row,'rwo');
                arr.push({
                    'areaCode': row.areaCode,
                    'blockName': row.block_name,
                    'blockAddress':row.pocAddress,
                    'bwContactPerson':row.bwContactPerson,
                    'areaName':row.areaName,
                    'timeList':row.timeList,
                })
                this.addSale(arr)
            }
        },
        addSale (val) {
            this.lockScroll()
            let arr = []
            let blockNamearr = []
            if (this.isSinglepoint) {
                var noAddnumber = 0
                for (let item of this.detailDTOList) {
                    if (item.regionCode == this.regionCodenew) {
                        noAddnumber = item.notReportCountQty
                    }
                }
                // console.log(noAddnumber,'noAddnumber-1');
            } else {
                var noAddnumber = this.partNumber(this.regionCodenew)
                // console.log(noAddnumber,'noAddnumber-02');
            }
            let igniteIdarr = []
            for (let item of this.tableData) {
                arr.push(item)
                blockNamearr.push(item.block_name)
                igniteIdarr.push(item.igniteId)
            }
            // console.log(igniteIdarr,'igniteIdarr');
            let setBblockarr = new Set (blockNamearr)
            let reviseObj = val
            let regionName = ''
            let buName = ''
            let buCode = ''
            for (let item of this.detailDTOList) {
                if (item.regionCode == this.regionCodenew) {
                    regionName = item.regionName
                    buName = item.buName
                    buCode = item.buCode
                }
            }
            let obj = {
                'themeCode' : this.themeDetail.themeStyleCode,
                'themeDetailId':this.themeDetail.themeDetailId,
                'igniteRuleObj':this.igniteOptionsnew,
                'pocCountMin':this.pocCountMin,
                'pocRelateType':this.themeDetail.pocRelateType,
                'reviseObj': reviseObj,
                'singleData': arr,
                'blockNamearr':setBblockarr,
                'notReportCountQty':this.notReportCountQty,
                'regionCode':this.regionCodenew,
                'themeBasic':this.popData.themeBasic,
                'needTransitions':this.themeDetail.needTransitions,
                'perExecDays':this.themeDetail.perExecDays,
                'noAddnumber' : noAddnumber,
                'regionName':regionName,
                'buName':buName,
                'buCode':buCode,
                'igniteIdarr':igniteIdarr,
                // 'previousPage':true
            }
            if (this.isSinglepoint) {
                this.searchList = obj
                this.isSingledialog = true
                this.isMask = true

            } else if (this.isManypoint) {
                this.searchList = obj
                this.isMask = true
                this.isManydialog = true

            } else if (this.isEmptypoint) {
                this.searchList = obj
                this.isMask = true
                this.isEmptydialog = true
            }
        },
        // 批量添加售点
        addManysale () {
            this.isPoverdialog = true
            // console.log('9999');
        },
        closePover () {
            this.isPoverdialog = false
        },
        closeMask () {
            this.unlockScroll()
            this.isMask = false
            this.isSingledialog = false
            this.isManydialog = false
            this.isEmptydialog = false
            this.isErrordialog = false
        },
        arrHandle (arr) {
            let popData = this.popData
            let array =JSON.parse(JSON.stringify(arr))
            let result = []
            array.map(e => {
                return {
                    'themeDetailId': popData.themeDetail.themeDetailId,
                    'regionCode':e.regionCode,
                    "submitCountDTOList":this.detailDTOList,
                    gpActivityTimeDTOList:e.timeList.map(time =>{
                        return {
                            'activityTime':time
                        }
                    }),
                    gpActivityInfoDTO: {
                        "beginTime": popData.themeBasic.themeStartTime,
                        "buToCity": popData.themeBasic.buToCity,
                        "endTime": popData.themeBasic.themeEndTime,
                        "themeChannelCode": popData.themeDetail.themeChannelCode,
                        themeChannelName:popData.themeDetail.themeChannelName,
                        "themeId": popData.themeBasic.themeId,
                        "themeLevelCode":  popData.themeDetail.themeLevelCode,
                        "themeStyleCode":  popData.themeDetail.themeStyleCode,
                        'themeDetailId': popData.themeDetail.themeDetailId,
                        "blockName":e.block_name,
                        "areaCode":e.areaCode, // 新加
                        "blockPoi":'',
                        "blockAddress":'',
                        "blockLongitude":'',
                        "blockLatitude":'',
                        "signInLongitude":'',
                        "signInLatitude":'',
                        'bwContactPerson':e.bwContactPerson,
                        "assignStartTime":  this.timeItem.assignStartTime,
                        "assignEndTime":  this.timeItem.assignEndTime,
                        'assignId':this.timeItem.assignId,
                        'regionCode':e.regionCode,
                        'themeLevelName':popData.themeDetail.themeLevelName,
                        'themeStyleName':popData.themeDetail.themeStyleName,
                    },
                    gpActivityPocDTOList: array.filter(g => g.block_name == e.block_name).map(h => {
                        return {
                            "cityName": h.cityName,
                            "contactPerson": h.contactPerson,
                            "contactPhone": h.contactPhone,
                            "igniteId": h.igniteId,
                            "pocAddress": h.pocAddress,
                            "pocName": h.pocName,
                            "pocPoiId": h.pocPoiId,
                            "provinceName": h.provinceName,
                            "locLongitude":h.locLongitude,
                            "locLatitude":h.locLatitude,
                            'pocDetail':h.pocDetail
                        }
                    })
                    }
                    }).forEach(e => {
                        result.push(e)
                        // result.findIndex(f => f.gpActivityInfoDTO?.block_name == e.gpActivityInfoDTO?.block_name) == -1 && result.push(e)
                    });
            for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < i; j++) {
                    if (result[i].gpActivityInfoDTO.blockName == result[j].gpActivityInfoDTO.blockName) {
                        result.splice(j,1)
                        i--
                    }
                }
            }
            if (result.length == 0) {
                let result = [{
                    gpActivityInfoDTO:{
                        themeLevelCode:popData.themeDetail.themeLevelCode,
                        themeStyleCode:popData.themeDetail.themeStyleCode,
                        "assignStartTime":  this.timeItem.assignStartTime,
                        "assignEndTime":  this.timeItem.assignEndTime,
                        'assignId':this.timeItem.assignId,
                        isEmptyvalue:true
                    }
                }]
                this.addPopsale(result)
            } else {
                this.addPopsale(result)
            }
        } ,
        aconfirmAddbtn () {
            this.dialogVisible = true
        },
        handleDialogclose () {
            this.dialogVisible = false
        },
        // 确认添加售点
        aconfirmAdd () {
            if (this.isSinglepoint) {
                let tableList = this.tableData
                let popData = this.popData
                let tableArr = []
                for (let item of tableList) {
                    let timeArr = []
                    for (let item2 of item.timeList) {
                        timeArr.push({
                            'activityTime':item2
                        })
                    }
                    tableArr.push({
                        "gpActivityInfoDTO":
                        {
                            "beginTime": popData.themeBasic.themeStartTime,
                            "buToCity": popData.themeBasic.buToCity,
                            "endTime": popData.themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            themeChannelName:popData.themeDetail.themeChannelName,
                            "themeId": popData.themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":'',
                            "areaCode":item.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            'bwContactPerson':item.bwContactPerson,
                            "assignStartTime":  this.timeItem.assignStartTime,
                            "assignEndTime":  this.timeItem.assignEndTime,
                            'assignId':this.timeItem.assignId,
                            'regionCode':item.regionCode,
                            'themeLevelName':popData.themeDetail.themeLevelName,
                            'themeStyleName':popData.themeDetail.themeStyleName,
                        }
                        ,
                        "gpActivityPocDTOList":
                        [{
                            "cityName": item.cityName,
                            "contactPerson": item.contactPerson,
                            "contactPhone": item.contactPhone,
                            "igniteId": item.igniteId,
                            "pocAddress": item.pocAddress,
                            "pocName": item.pocName,
                            "pocPoiId": item.pocPoiId,
                            "provinceName": item.provinceName,
                            "locLongitude":item.locLongitude,
                            "locLatitude":item.locLatitude,
                            'pocDetail':item.pocDetail
                        }],
                        'gpActivityTimeDTOList':timeArr,
                        'themeDetailId': popData.themeDetail.themeDetailId,
                        'regionCode':item.regionCode,
                        "submitCountDTOList":this.detailDTOList,
                    })
                }
                if (tableArr.length == 0) {
                    let result = [{
                            gpActivityInfoDTO:{
                                themeLevelCode:popData.themeDetail.themeLevelCode,
                                themeStyleCode:popData.themeDetail.themeStyleCode,
                                "assignStartTime":  this.timeItem.assignStartTime,
                                "assignEndTime":  this.timeItem.assignEndTime,
                                'assignId':this.timeItem.assignId,
                                isEmptyvalue:true
                            }
                        }]
                    this.addPopsale(result)
                } else {
                    this.addPopsale(tableArr)
                }

            } else if (this.isManypoint) {
                let tableList =JSON.parse(JSON.stringify(this.tableData))
                this.arrHandle(tableList)
            } else if (this.isEmptypoint) {
                let arr = []
                let popData = this.popData
                for (let i = 0; i < this.tableData.length; i++) {
                    let timeArr = []
                    for (let item2 of this.tableData[i].timeList) {
                        timeArr.push({
                            'activityTime':item2
                        })
                    }
                    arr.push(
                        {
                            "gpActivityInfoDTO": {
                                "beginTime": popData.themeBasic.themeStartTime,
                                "buToCity": popData.themeBasic.buToCity,
                                "endTime": popData.themeBasic.themeEndTime,
                                "themeChannelCode": popData.themeDetail.themeChannelCode,
                                themeChannelName:popData.themeDetail.themeChannelName,
                                "themeId": popData.themeBasic.themeId,
                                "themeLevelCode":  popData.themeDetail.themeLevelCode,
                                "themeStyleCode":  popData.themeDetail.themeStyleCode,
                                'themeDetailId': popData.themeDetail.themeDetailId,
                                "blockName":this.tableData[i].block_name,
                                "areaCode":this.tableData[i].areaCode, // 新加
                                "blockPoi":'',
                                "blockAddress":this.tableData[i].pocAddress,
                                "blockLongitude":'',
                                "blockLatitude":'',
                                "signInLongitude":'',
                                "signInLatitude":'',
                                'bwContactPerson':this.tableData[i].bwContactPerson,
                                "assignStartTime":  this.timeItem.assignStartTime,
                                "assignEndTime":  this.timeItem.assignEndTime,
                                'assignId':this.timeItem.assignId,
                                'regionCode':this.tableData[i].regionCode,
                                'themeLevelName':popData.themeDetail.themeLevelName,
                                'themeStyleName':popData.themeDetail.themeStyleName,
                            },
                            "gpActivityPocDTOList": [],
                            'gpActivityTimeDTOList':timeArr,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            'regionCode':this.tableData[i].regionCode,
                            "submitCountDTOList":this.detailDTOList,
                        }
                    )
                }
                if (arr.length == 0) {
                    let result = [{
                            gpActivityInfoDTO:{
                                themeLevelCode:popData.themeDetail.themeLevelCode,
                                themeStyleCode:popData.themeDetail.themeStyleCode,
                                "assignStartTime":  this.timeItem.assignStartTime,
                                "assignEndTime":  this.timeItem.assignEndTime,
                                'assignId':this.timeItem.assignId,
                                isEmptyvalue:true
                            }
                        }]
                    this.addPopsale(result)
                } else {
                    this.addPopsale(arr)
                }
            }
        },
        addPopsale(item) {
            this.$emit('addPopsale',item)
        },
        // 数组去重，删除后面的数据
        arrayUnique(arr, name) {
            let hash = {}
            return arr.reduce(function(acc, cru, index) {
                if (!hash[cru[name]]) {
                    hash[cru[name]] = { index: index }
                    acc.push(cru)
                } else {
                    acc.splice(hash[cru[name]]['index'], 1, cru)
                }
                return acc
            }, [])
        },
        // 单售点选择
        handleChange (val) {
            // console.log(val,'val');
            for (let item of val) {
                this.tableData.push(item)
            }
            let arr = this.arrayUnique(this.tableData, 'igniteId')
            this.tableData = arr
            this.aconfirmAdd()
        },
        // 多售点选择
        handleSelectionChange (val) {
            // console.log(val);
            if (this.tableData.length > 0 && val[0].startFoodstreet !== '') {
                let startFoodstreet =  val[0].startFoodstreet
                for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].block_name == startFoodstreet){
                        this.tableData.splice(i,1)
                        i--
                    }
                }
            }
            if (this.tableData.length > 0) {
                let block_name =  val[0].block_name
                for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].block_name == block_name){
                        this.$message.warning('街区已存在，请重新选择')
                        return
                    }
                }
            }
            let a = JSON.parse(JSON.stringify(val))
            this.$nextTick(() => {
                this.tableData = this.tableData.concat(a)

                let dataArr = []
                this.tableData.map((mapItem) => {
                if (dataArr.length == 0) {
                    dataArr.push({ block_name: mapItem.block_name, List: [mapItem] })
                } else {
                    let res = dataArr.some((item) => {
                    //判断相同的部门，有就添加到当前项
                    if (item.block_name == mapItem.block_name) {
                        item.List.push(mapItem)
                        return true
                    }
                    })
                    if (!res) {
                    //如果没找相同的部门添加一个新对象
                    dataArr.push({ block_name: mapItem.block_name, List: [mapItem] })
                    }
                }
                })
                this.aconfirmAdd()
                // myTable是表格的ref属性值
                if (this.$refs.myTable && this.$refs.myTable.doLayout) {
                    this.merge(this.tableData)
                    this.$refs.myTable.doLayout();
                }
            })

        },
        // 无售点
        handleEmptyChange (val) {
            // console.log(val,'000');
            if (this.tableData.length > 0) {
                for (let i = 0; i < this.tableData.length; i++) {
                    if (this.tableData[i].block_name == val[0].block_name && this.tableData[i].pocAddress == val[0].pocAddress && this.tableData[i].areaCode == val[0].areaCode) {
                        this.$message.warning('街区售点已存在，请重新选择')
                        return
                    }
                }
            }
            this.tableData =  this.tableData.concat(val)
            this.aconfirmAdd()
        }
    }
}
</script>
<style lang="scss" scoped>
.el-popover.myPopover{
    .muban {
        display: flex;
        color: #101010;
        // height: 40px;
        line-height: 40px;
        .left {
            width: 25%;
            font-size: 14px;
            font-weight: bold;
        }
        .right {
            font-size: 12px;
            color: rgb(0, 117, 255);
            cursor: pointer;
        }
    }
    .shuju {
        display: flex;
        color: #101010;
        .left {
            width: 25%;
            font-size: 14px;
            font-weight: bold;
            // height: 40px;
            line-height: 40px;
        }
        .right {
            font-size: 12px;
            color: rgb(0, 117, 255);
            cursor: pointer;
            .right-top {
                width: 70px;
                line-height: 25px;
                color: #FFFFFF;
                background-color: rgb(0, 117, 255);
                border-radius: 3px;
                text-align: center;
                margin-top: 7.5px;
            }
            .text {
                // height: 20px;
                line-height: 20px;
                color: #CD1231;
            }
            ::v-deep .el-upload-list__item-name {
                white-space: normal !important;
            }
        }
    }
}
.tab-item {
    // margin-top: 10px;
    // background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    font-size: 14px;
    text-align: left;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }

    .btn {
        display: flex;
        width: 20%;
        margin-left: 80%;
        height: 42px;
    }
    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -40px;
        height: 32px;
        line-height: 32px;
    }
    .item-sale {
        width: 100%;
        .left {
            // width: 90%;
            width: 100%;
            height: 42px;
            line-height: 42px;
            display: flex;
            font-size: 14px;
            .div0 {
                font-size: 18px;
                font-weight: 600;
                margin-right: 20px;
            }
            .div1 {
                font-weight: normal;
            }
            .div2 {
                flex: 1;
                display: flex;
                justify-content: flex-end;
            }
        }
        .right {
            margin-top: 10px;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
                // font-weight: normal !important;
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .store-name {
                color: #409EFF;
                cursor: pointer;
            }
            .input-baiwei {
                color: #CD1231;
                ::v-deep .el-input__inner {
                    color: #CD1231;
                }

            }
        }
    }
}
.mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7) ;
        z-index: 3;
    }
.color-grey{
    border-color: 1px soild gray !important;
    background-color: gray !important;
}

.dialog {
        position: fixed;
        top: 5vh;
        left: calc((100vw - 1000px)/2);
        width: 1000px;
        padding: 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        z-index: 3;
        max-height: 90vh;
    }
.dialog2 {
    position: fixed;
    top: 25%;
    left: calc((100vw - 600px)/2);
    width: 600px;
    // height: 300px;
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
}
.dialogError{
    position: fixed;
    top: 15%;
    left: calc((100vw - 840px)/2);
    width: 800px;
    padding:20px 20px 20px 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
    .dialogError-top {
        line-height: 18px;
        font-size: 18px;
        text-align: center;
        font-weight: 600;
        display: flex;
        margin-bottom: 10px;
    }
    .dialogError-main {
        max-height: 300px;
        overflow: hidden;
        overflow-y: auto;
        ::v-deep .el-table th.el-table__cell {
            color: #101010;
            background-color: rgba(232, 232, 232);
        }
        ::v-deep .el-table__body tr.current-row>td.el-table__cell {
            background-color: #FFFFFF !important;
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
            background-color: #FFFFFF !important;
        }
    }
}
</style>
